import { DS_BREAKPOINT, DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import { useIsMobile } from '@rhg/hooks/use-is-mobile';
import { Box, Button, ButtonProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';

export const BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP = 72;
export const BOTTOM_ACTION_SECTION_HEIGHT_MOBILE = 64;

const styleBottomActions = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    py: 1,
    display: 'flex',
    justifyContent: 'center',
    height: {
        xs: BOTTOM_ACTION_SECTION_HEIGHT_MOBILE,
        sm: BOTTOM_ACTION_SECTION_HEIGHT_MOBILE,
        md: BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP,
        lg: BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP,
    },
    px: {
        sm: DS_SPACING_UNITS.SIDE_SMALL,
        md: DS_SPACING_UNITS.SIDE_MEDIUM,
        lg: DS_SPACING_UNITS.SIDE_LARGE,
    },
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? 'background.paper'
            : 'background.primary',
    borderTop: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? `1px solid ${theme.palette.divider}`
            : 'none',
};

const styleButtonsContainer = {
    width: '100%',
    maxWidth: DS_BREAKPOINT.MEDIUM,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: { xs: 'column-reverse', sm: 'column-reverse', md: 'row' },
};

const styleButton = {
    width: '100%',
    maxWidth: { xs: '100%', sm: '100%', md: DS_BREAKPOINT.MEDIUM },
    mx: { xs: 0, sm: 0, md: 2 },
    my: 2,
};

interface BottomActionProps extends ButtonProps {
    label: string;
}

export function BottomAction({ label, ...buttonProps }: BottomActionProps) {
    const isMobile = useIsMobile('md');

    return (
        <Box sx={styleBottomActions}>
            <Box sx={styleButtonsContainer}>
                <Button
                    size={isMobile ? 'medium' : 'large'}
                    {...buttonProps}
                    sx={sxAppend(styleButton, buttonProps.sx)}
                >
                    {label}
                </Button>
            </Box>
        </Box>
    );
}
